/* PDP only (loaded by sections/main-product.liquid): "see with sleeve logo" toggle -> colour swatches slide in from the left */
(function () {
  if (!document.body.classList.contains('product')) return;

  var CLASS = 'pdp-swatch-slide';
  var timer;

  function bind() {
    var toggle = document.getElementById('dark-mode');
    if (!toggle) return false;

    toggle.addEventListener('change', function () {
      var body = document.body;
      body.classList.remove(CLASS);
      void body.offsetWidth; // restart the animation on every toggle
      body.classList.add(CLASS);
      clearTimeout(timer);
      timer = setTimeout(function () {
        body.classList.remove(CLASS);
      }, 1200);
    });
    return true;
  }

  if (!bind()) document.addEventListener('DOMContentLoaded', bind);
})();
